
<template>
  <div class="page" ref="pageRef">
    <div class="page_top_bg">
      <img
        src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934953643/core_top_bg.png"
      />
    </div>
    <div class="page_wrap">
      <div
        class="core_item"
        ref="coreRef"
        v-for="(item, index) in coreList"
        :key="index"
      >
        <div style="background: #f4f6f7; height: 74px"></div>
        <div class="item1" v-if="index == 0">
          <div class="core_content">
            <div class="core_title">
              <img :src="item.icon" />
              <span v-html="item.title"></span>
            </div>
            <div class="core_text">
              对建设项目全生命周期提供组织
              、管理、经济和技术等各有关方面的工程咨询服务。包括项目的全过程管理以及投资咨询、勘察、设计、造价咨询、招标代理、监理、运行维护咨询等工程建设项目各阶段专业咨询服务。提供从项目策划、设计、施工到投运及后续维护等全方位的咨询服务，确保不同阶段的工作协调一致。
            </div>
            <div class="core_text">
              我们拥有一支专业的技术团队，熟悉各类工程的规划、设计、建设和管理要求，能够提供建议和解决方案。在多年的实践中积累了丰富的经验和案例，能够通过优化设计和施工流程、降低成本、提高效率和品质等方面实现精益化管理。预测和识别可能存在的问题和隐患，并制定相应的措施和预案，以减少项目实施过程中的风险和不确定性，加强项目管理，降低成本，提高效率和品质，最大限度地提高项目收益。
            </div>
            <div class="core_icon">
              <div
                class="icon_item icon_5"
                v-for="(label, idx) in item.serveList"
                :key="idx"
              >
                <div class="item_img">
                  <img :src="label.icon" />
                </div>
                <div class="item_title">
                  {{ label.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="core_pic">
            <img :src="item.pic" />
          </div>
        </div>
        <div v-if="index == 1">
          <div class="item1">
            <div class="core_content">
              <div class="core_title">
                <img :src="item.icon" />
                <span v-html="item.title"></span>
              </div>
              <div class="core_text">
                1、建设项目投资估算的编制、审核及项目经济评价；<br />
                2、工程概算、预算、结算、竣工决算、工程招标标底价、投标报价的编制、审核；<br />
                3、工程变更及合同价款的调整和索赔费用的计算；<br />
                4、建设项目各阶段的工程造价控制；<br />
                5、工程经济纠纷的鉴定；<br />
                6、工程造价计价依据的编制、审核；<br />
                7、与工程造价业务有关的其他事项。<br />
              </div>
              <div class="core_text">
                企业内部建立了系统性与一致性的组织体系及工作流程，确保组织体系与工作体系的完整性。提供涵盖项目决策、设计、招投标、施工、竣工结算及后期审计等一系列服务的过程。通过系统化、专业化的方法，实现对项目成本的有效控制和优化。
              </div>
              <div class="core_text">
                强调与项目各参与方（如业主、设计师、承包商等）之间的紧密合作与沟通，通过建立有效的信息共享机制和协调平台，促进各方之间的协作效率，避免信息孤岛现象的发生。熟悉并遵守国家及地方关于建设工程领域的相关法律法规及标准规范要求,
                确保所有操作流程合法合规且具有较高的透明度。
              </div>
            </div>
            <div class="core_pic">
              <img :src="item.pic" />
            </div>
          </div>
          <div
            class="core_icon"
            style="
              padding: 0px 44px;
              display: flex;
              justify-content: space-around;
            "
          >
            <div
              class="icon_item icon_6"
              v-for="(label, idx) in item.serveList"
              :key="idx"
            >
              <div class="item_img">
                <img :src="label.icon" />
              </div>
              <div class="item_title">
                {{ label.title }}
              </div>
            </div>
          </div>
          <div class="item1" style="margin-top: 58px; width: 1200px">
            <div class="core_pic">
              <img :src="item.pic2" />
            </div>
            <div class="person_left">
              <div class="person_title">公司现有专业造价人员</div>
              <div class="person_img">
                <img
                  src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935299598/person_img1.png"
                  alt=""
                />
                <img
                  src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935319303/person_img2.png"
                  alt=""
                />
              </div>
              <div class="person_text">
                人员具备深厚的造价管理专业知识，了解成本核算、预算编制和项目估算等各个方面的专业知识和技能；可以通过合理的成本控制和预算管理，为项目的顺利进行提供支持。
              </div>
              <div class="person_text">
                在造价管理领域具有较长时间的从业经验，能够应对各类项目的造价管理挑战；熟悉市场行情和政策法规，能够快速准确地为业主提供专业建议能够准确分析项目成本结构，为企业提供具有实际意义的预算和投资建议。
              </div>
            </div>
          </div>
        </div>
        <div v-if="index == 2">
          <div class="item1">
            <div class="core_content">
              <div class="core_title">
                <img :src="item.icon" />
                <span v-html="item.title"></span>
              </div>
              <div class="core_text">
                主要从事各类工程、物资、设备、服务等招标代理业务，包括政府采购代理、工程招标代理、物资采购代理等。我司自成立以来，累计完成各类招标代理项目数千项，涉及工程建设、政府采购、科研、金融等多个领域。在长期的业务实践中，我们积累了丰富的行业经验，能够为客户提供专业、高效的招标代理服务
              </div>
              <div class="core_text">
                我司建立了完善的招标体系，包括招标策划、招标文件编制、招标公告发布、投标人资格审查、开标、评标、中标公示等环节。在招标过程中，我们严格按照法律法规和招标文件的要求，确保招标过程的公开、公平、公正。高度重视招标项目的保密工作，建立健全保密制度，确保招标信息的安全。在招标过程中，我们对招标文件、评标结果等敏感信息进行严格保密，确保招标活动的顺利进行。
              </div>
            </div>
            <div class="core_pic">
              <img :src="item.pic" />
            </div>
          </div>
          <div
            class="core_icon"
            style="
              padding: 0px 44px 32px;
              display: flex;
              justify-content: space-between;
            "
          >
            <div
              class="icon_item icon_5"
              v-for="(label, idx) in item.serveList"
              :key="idx"
            >
              <div class="item_img">
                <img :src="label.icon" />
              </div>
              <div class="item_title">
                {{ label.title }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="index == 3">
          <div class="item1">
            <div class="core_content">
              <div class="core_title">
                <img :src="item.icon" />
                <span v-html="item.title"></span>
              </div>
              <div class="core_text">
                开展相应资质等级类别的建设工程的项目管理、技术咨询等业务。已涵盖工程建设服务的所有范围，从工程投资风险收益预测，市场预测，至招投标，前期手续代理，工程建设监理，工程造价咨询等，已形成综合优势。这些服务将为您带来费用上的很大节约，手续上的简化，同时更重要是使您的工程有一个完整、规范的、全局性的运作，这比各部分分散操作大大节约了资金、人力、物力及时间。
              </div>
              <div
                style="
                  margin-top: 32px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <img
                  src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935716259/person_img3.png"
                  alt=""
                />
                <img
                  src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935716290/person_img4.png"
                  alt=""
                />
              </div>
              <div class="core_text">
                中致远现有注册全国监理工程师 45 人、其他专业监理从业人员 50
                余人，注册专业涵盖房屋建筑工程、化工石油工程、水利水电工程、电力工程、公路工程、通信工程、市政公用工程、机电安装工程等。特别成立业务专家组，专家组包含国家级监理工程师，国家造价工程师，电气工程专家，地基与基础工程专家，装饰工程专家、测绘工程专家等。这些专家在关键部位为您们把关，审查重大技术方案等，他们可以其多年丰富的经验和扎实的理论为您排忧解难。
              </div>
              <div class="core_text">
                监理人员的不规范行为可能会给业主造成不利局面，因此，建立完整规范的廉洁监督体制是极为重要的。我司拥有二级监督机制，第一级为建立业主廉洁联系卡，定期回访业主，由业主协助监督。第二级为本司监理部检查监督，定期汇同工地总监，部门领导检查、评比。
              </div>
            </div>
            <div class="core_pic">
              <img :src="item.pic" />
            </div>
          </div>
          <div
            class="core_icon"
            style="
              padding: 0px 44px 32px;
              display: flex;
              justify-content: space-around;
            "
          >
            <div
              class="icon_item icon_6"
              v-for="(label, idx) in item.serveList"
              :key="idx"
            >
              <div class="item_img">
                <img :src="label.icon" />
              </div>
              <div class="item_title">
                {{ label.title }}
              </div>
            </div>
          </div>
        </div>
        <div class="item1" v-if="index == 4">
          <div class="core_content">
            <div class="core_title">
              <img :src="item.icon" />
              <span v-html="item.title"></span>
            </div>
            <div class="core_text">
              开展相应资质等级类别的建设工程的项目管理、技术咨询等业务。通过运用综合项目管理知识、技能、工具和技术，对项目活动进行有效的启动、规划、执行、监控、和收尾，确保项目按照既定目标顺利完成。
            </div>
            <div class="core_text">
              通过全面风险识别、评估，制定和执行应对计划，有效降低项目风险，保障项目顺利进行。可预测和识别可能存在的问题和隐患，并制定相应的措施和预案，以减少项目实施过程中的风险和不确定性。
            </div>
            <div class="core_text">
              与客户的持续沟通和交流，及时了解客户的需求变化，相应调整项目计划，确保项目成果符合客户的最新需求并确保项目成果满足甚至超过客户期望。全面分析项目、资源需求和资源状况，通过对现有资源的评估和分配，协助业主、项目管理对象实现项目资源的最优配置。
            </div>
            <div class="core_icon">
              <div
                class="icon_item icon_4"
                v-for="(label, idx) in item.serveList"
                :key="idx"
              >
                <div class="item_img">
                  <img :src="label.icon" />
                </div>
                <div class="item_title">
                  {{ label.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="core_pic">
            <img :src="item.pic" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onUnmounted, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";

import { ref } from "vue";

import {
  defineComponent,
  toRefs,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";

export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance() as any;
    const route = useRoute();
    const router = useRouter();

    const blue = (title: any) => {
      return `<span style="color:#1B7FEB">${title}</span>`;
    };
    const state = reactive({
      coreList: [
        {
          title: `全过程${blue("工程咨询")}`,
          icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934974963/core_item_icon1.png",
          serveList: [
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935128686/core_serve1_icon1.png",
              title: "综合性",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935128709/core_serve1_icon2.png",
              title: "专业性",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935128844/core_serve1_icon3.png",
              title: "精益化",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935128945/core_serve1_icon4.png",
              title: "降低风险",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935129078/core_serve1_icon5.png",
              title: "综合性",
            },
          ],
          pic: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935104488/core_serve1_img.png",
        },
        {
          title: `全过程${blue("造价")}咨询`,
          icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934975000/core_item_icon2.png",
          serveList: [
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935349200/core_serve2_icon1.png",
              title: "全面覆盖项目周期",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935349231/core_serve2_icon2.png",
              title: "精细化管理",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935349351/core_serve2_icon3.png",
              title: "风险预控",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935349471/core_serve2_icon4.png",
              title: "协同效应",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935349602/core_serve2_icon5.png",
              title: "技术应用",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935349631/core_serve2_icon6.png",
              title: "法律法规遵从性",
            },
          ],
          pic: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/31/1743387559460/core_serve2_img.png",
          pic2: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935268231/core_serve2_img.png",
        },
        {
          title: `${blue("招标与采购")}专业咨询`,
          icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934975073/core_item_icon3.png",
          serveList: [
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935528489/core_serve3_icon1.png",
              title: "丰富的行业经验",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935528593/core_serve3_icon3.png",
              title: "完善的招标体系",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935528758/core_serve3_icon5.png",
              title: "严格的保密制度",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935528863/core_serve3_icon6.png",
              title: "全面的服务保障",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935528976/core_serve3_icon7.png",
              title: "良好的社会信誉",
            },
          ],
          pic: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/31/1743388772062/core_serve3_img.png",
        },
        {
          title: `${blue("工程监理与运维")}专业咨询`,
          icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934975198/core_item_icon4.png",
          serveList: [
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935791825/core_serve4_icon1.png",
              title: `多专业总体综合优势`,
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935791855/core_serve4_icon2.png",
              title: "工程风险预测优势",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935791956/core_serve4_icon3.png",
              title: "咨询团队整合优势",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935792005/core_serve4_icon4.png",
              title: `完整规范的廉洁监督体制`,
            },
          ],
          pic: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/31/1743389403734/core_serve4_img.png",
        },
        {
          title: `全过程${blue("项目管理")}`,
          icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741934975233/core_item_icon5.png",
          serveList: [
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935938394/core_serve5_icon1.png",
              title: "能提高项目成功率",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935938428/core_serve5_icon2.png",
              title: "协助优化资源配置",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935938658/core_serve5_icon4.png",
              title: "提升决策质量",
            },
            {
              icon: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741935938689/core_serve5_icon5.png",
              title: "客户至上",
            },
          ],
          pic: "https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/31/1743389170034/core_serve5_img.png",
        },
      ],
    });
    const pageRef = ref();
    const coreRef = ref();

    onMounted(() => {});

    onUnmounted(() => {});
    const scrollToTop = () => {
      let type: any = route.query.type;
      if (type == 0) {
        coreRef.value[0].scrollIntoView({ behavior: "smooth" });
      } else if (type == 1) {
        coreRef.value[1].scrollIntoView({ behavior: "smooth" });
      } else if (type == 2) {
        coreRef.value[2].scrollIntoView({ behavior: "smooth" });
      } else if (type == 3) {
        coreRef.value[3].scrollIntoView({ behavior: "smooth" });
      } else if (type == 4) {
        coreRef.value[4].scrollIntoView({ behavior: "smooth" });
      } else {
        pageRef.value.scrollIntoView({ behavior: "smooth" });
      }
    };
    watchEffect(() => {
      if (route.query.type) {
        setTimeout(() => {
          scrollToTop();
        }, 0);
      }
    });
    return {
      coreRef,
      pageRef,
      ...toRefs(state),
    };
  },
});
</script>
<style scoped lang="scss">
.page {
  .page_top_bg {
    width: 100%;
    height: 426px;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 426px;
      object-fit: cover;
    }
  }
  .page_wrap {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    z-index: 10;
    .core_item {
      margin-bottom: 64px;
      width: 1200px;
      background: #ffffff;
      .core_content {
        padding: 48px 44px 0px;
        .core_title {
          display: flex;
          align-items: center;
          img {
            display: block;
            margin-right: 24px;
          }
          span {
            font-weight: bold;
            font-size: 32px;
            color: #000000;
          }
        }
        .core_text {
          margin-top: 24px;
          font-size: 16px;
          color: #000000;
        }
      }
      .person_left {
        width: 800px;
        .person_title {
          text-align: center;
          font-size: 24px;
          color: #000000;
        }
        .person_img {
          display: flex;
          justify-content: center;
          padding: 30px 0px 20px;
          img {
            display: block;
            margin: 0 15px;
          }
        }
        .person_text {
          padding: 24px 44px 0px;
          font-size: 16px;
          color: #000000;
        }
      }
      .core_icon {
        display: flex;
        justify-content: space-between;
        .icon_item {
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
          text-align: center;
          padding-bottom: 10px;
          .item_img {
            margin: 10px auto;
            img {
              margin: 0 auto;
              display: block;
            }
          }
          .item_title {
            font-weight: bold;
            font-size: 20px;
            color: #1b7feb;
          }
        }
      }
      .icon_5 {
        width: calc(100% / 5 - 15px);
        margin-top: 24px;
      }
      .icon_6 {
        padding: 0px 30px 24px;
        margin-top: 40px;
      }
      .icon_4 {
        padding: 0px 16px;
        margin-top: 40px;
      }
      .core_pic {
        img {
          display: block;
        }
      }
    }
    .item1 {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
  